var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../../interface/IVueDialog";
import ClientService from '../../../../api/ClientService';
import LeftTree from './LeftTree';
import TabTable from './TabTable.vue';
import _ from 'lodash';
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var AddClient = (function (_super) {
    __extends(AddClient, _super);
    function AddClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.treeData = [];
        _this.tableData = [];
        _this.total = 0;
        _this.curGoodNode = [];
        _this.activeName = '0';
        _this.selectRows = [];
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.customerFromList = [];
        _this.formData = {
            from_system: '-1'
        };
        return _this;
    }
    AddClient.prototype.created = function () {
        this.service = ClientService.getInstance();
        this.getLeftTree();
        this.getCustomerFrom();
    };
    AddClient.prototype.mounted = function () {
    };
    AddClient.prototype.getCustomerFrom = function () {
        var _this = this;
        this.service.getCustomerFrom().then(function (res) {
            if (res.data && res.data.success) {
                (res.data.data || []).unshift({
                    name: '全部来源',
                    value: '-1'
                });
                _this.customerFromList = res.data.data;
            }
        });
    };
    AddClient.prototype.gitRightList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var params = {
            business_name: this.formData.business_name,
            from_system: this.formData.from_system
        };
        if (this.curGoodNode && this.curGoodNode.group_id != '-1') {
            params = Object.assign({}, params, {
                group_id: this.curGoodNode.group_id
            });
        }
        var business_ids;
        business_ids = (this.addedDatas || []).map(function (item) {
            return item.business_id;
        });
        this.service.getClientList(Object.assign({}, params, {
            not_business_ids: (business_ids || []).join(',')
        }, pager)).then(function (res) {
            if (res.data.success) {
                _this.tableData = res.data.data;
                _this.unSelectList = res.data.data;
                _this.total = res.data.total;
                _this.setSelected(true);
            }
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddClient.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), 'business_id');
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (good) { return good.business_id === currentRow.business_id; })) {
            _.remove(this.selectedList, function (good) { return good.business_id === currentRow.business_id; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item.business_id === good.business_id; });
            });
        }
        this.setSelected(this.activeName === EActiveType.SELECTED);
        setTimeout(function () {
            _this.canFreshTable = true;
        });
    };
    AddClient.prototype.handleClick = function (tab, event) {
        if (tab.name == "second") {
            this.setSelected();
        }
    };
    AddClient.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.selectedList.forEach(function (good, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(good, true);
                });
                if (isUnSelFresh) {
                    var item_1 = _.find(_this.unSelectList, function (current) { return current.business_id === good.business_id; });
                    _this.$nextTick(function () {
                        gridTable.toggleRowSelection(item_1, true);
                    });
                }
            });
        }
    };
    AddClient.prototype.getLeftTree = function () {
        var _this = this;
        this.service.getGroups().then(function (res) {
            _this.treeData = [{
                    group_id: '-1',
                    group_name: '全部',
                    children: res.data.data
                }];
        });
    };
    AddClient.prototype.search = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.gitRightList();
    };
    AddClient.prototype.close = function () {
        this.$closeDialog();
    };
    AddClient.prototype.save = function () {
        var data = _.uniqBy(this.selectedList, 'business_id');
        this.$emit('save:ok', data);
    };
    AddClient.prototype.nodeClick = function (node) {
        this.curGoodNode = node || null;
        this.gitRightList();
    };
    AddClient.prototype.pageChange = function (pager) {
        this.gitRightList(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    AddClient = __decorate([
        Component({
            components: {
                'left-tree': LeftTree,
                'tab-table': TabTable
            }
        })
    ], AddClient);
    return AddClient;
}(VueDialog));
export default AddClient;
